export function finishTestForm($currForm) {
    let $resultWrap = $currForm.find('.js-result-wrapper');
    let $testsWrap = $currForm.find('.js-tests-wrapper');

    $('.js-questions-item').removeClass('_showen');
    $resultWrap.addClass('_show-results');
    scrollToElement($testsWrap);
    App.H.addClass('_finish');
}
